import { Util,Request, Cookie } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios } = Request;

const URL = getOrigin("www") + "/xt-notice/";
const URL2 = getOrigin("www") + "/xt-message/";

//获取信息列表
export function getuserLetterList(config) {
  return XtAxios.get(URL2 + `private/user-letter/list`, config);
}

//设置站内信已读
export function userLetterRead(arg, config) {
  return XtAxios.put(URL2 + `private/user-letter/read${arg.userLetterId ? "?userLetterId=" + arg.userLetterId : ""}`, null, config);
}

export function getschedule(config) {
  return XtAxios.get(URL + `public/schedule/list?time=${config.time}&lang=${config.lang}`, config);
}